<template>
  <div class="main" :class="{'bottom-sheet-open' : bottomSheetOpen }">
    <PageLoader :isActive="isLoading"/>
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <div class="zero-notification uhoh mb-x4" v-if="zohoError">
            <div class="zero-notification-icon"></div>
            ZOHO Error: {{ zohoError }}
          </div>
          <router-link to="/jobs" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </router-link>
          <h4 class="d-flex">
            {{ eventData.event_name }}
            <span class="ml-x2 zero-badge align-self-center" v-if="zohoId">ZOHO</span>
          </h4>
          <div class="italic color-grayscale-3" v-if="cachedon">
            cached on: {{ cachedon }} EST
            <button class="zero-btn zero-btn-tertiary" @click="getZohoJob(true)" v-if="userData.permissions[0] === '1'">refresh cache</button>
          </div>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col-md-6">
          <template v-if="eventId">
            <router-link :to="'/jobs/edit/' + eventId" v-if="userData.permissions[0] === '1'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline zero-btn-full mb-x3">
              <i class="fas fa-pen mr-x1"></i>Edit Job
            </router-link>
          </template>
          <div class="value pre-wrap mb-x2 h6">{{ eventData.location }}</div>
          <CreativesList v-if="eventData.creatives && eventId && users.length !== 0" :allUsers="users" :creatives="eventData.creatives" class="mb-x2" />
          <CreativesList v-if="eventData.creatives && zohoId" :creatives="eventData.creatives" class="mb-x2" zoho/>
          <!-- prevented for zoho -->
          <template v-if="eventId">
            <div class="mb-x4">
              <div class="day-item stacked" v-for="(day, dayindex) in eventData.days" :key="dayindex">
                <div class="date-info">
                  <div class="month">
                    {{ parseDate(day.date, 'month').slice(0, 3) }}
                  </div>
                  <div class="day">
                    {{ parseDate(day.date, 'day').padStart(2, '0') }}
                  </div>
                </div>
                <div class="time-span">
                  <div class="times-info">
                    <div class="fontweight-semibold time-value">{{ amPmConvert(day.start_time) }}</div>
                    <div class="time-label">Start</div>
                  </div>
                  <div class="time-hyphen"></div>
                  <div class="times-info">
                    <div class="fontweight-semibold time-value">{{ amPmConvert(day.end_time) }}</div>
                    <div class="time-label">End</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="zohoId">
            <div class="mb-x4">
              <div class="day-item stacked" v-for="(day, dayindex) in eventData.days" :key="dayindex">
                <div class="date-info">
                  <div class="month">
                    {{ parseDate(day.date, 'month').slice(0, 3) }}
                  </div>
                  <div class="day">
                    {{ parseDate(day.date, 'day').padStart(2, '0') }}
                  </div>
                </div>
                <div class="time-span">
                  <div class="times-info">
                    <div class="fontweight-semibold time-value">{{ day.start_time }}</div>
                    <div class="time-label">Start</div>
                  </div>
                  <div class="time-hyphen"></div>
                  <div class="times-info">
                    <div class="fontweight-semibold time-value">{{ day.end_time }}</div>
                    <div class="time-label">End</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- end zoho block -->
          <div class="d-flex mb-x4">
            <img class="d-block rocket-icon mr-x1" src="/images/rocket@2x.png">
            <div class="value pre-wrap">CALL TIME: {{ eventData.calltime }}</div>
          </div>
          <!-- ZOHO BLOCKED -->
          <div class="mb-x2" v-if="eventId">
            <router-link :to="'/jobs/' + eventId + '/shotlist'" class="zero-btn zero-btn-standard zero-btn-primary mb-x2 zero-btn-full">
              <i class="fas fa-camera mr-x1"></i>Shotlist
            </router-link>
            <router-link :to="'/jobs/' + eventId + '/general'" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline mb-x2 zero-btn-full">
              <i class="far fa-check-circle mr-x1"></i>General
            </router-link>
          </div>
          <!-- END ZOHO BLOCK -->
          <!-- ZOHO ONLY -->
          <div class="mb-x2" v-if="zohoId">
            <router-link :to="'/jobs/z' + zohoId + '/zshotlist'" class="zero-btn zero-btn-standard zero-btn-primary mb-x2 zero-btn-full">
              <i class="fas fa-camera mr-x1"></i>Shotlist
            </router-link>
          </div>
          <template v-if="zohoId">
            <BottomSheetClick name="parking & arrival" html :htmlcontent="eventData.travel" class="mb-x2"/>
            <BottomSheetClick name="flight / hotel" html :htmlcontent="eventData.flighthotel" class="mb-x2"/>
            <BottomSheetClick name="team assignments" html :htmlcontent="eventData.assignments" class="mb-x2"/>
            <BottomSheetClick name="headshot cafe" html :htmlcontent="eventData.headshotcafe" class="mb-x2"/>
            <BottomSheetClick name="video" html :htmlcontent="eventData.video" class="mb-x2"/>
            <BottomSheetClick v-if="eventData.services && eventData.services.length > 0" name="services" array :arraydata="eventData.services" class="mb-x2"/>
            <BottomSheetClick name="onsite info" html :htmlcontent="eventData.onsite" class="mb-x2"/>
            <BottomSheetClick name="meals" :content="eventData.meals" class="mb-x2"/>
            <BottomSheetClick name="additional details" html :htmlcontent="eventData.details" class="mb-x2"/>
            <BottomSheetClick name="EC Photog guidelines" :content="eventData.guidelines" class="mb-x2"/>
            <BottomSheetClick name="EC program agenda" :content="eventData.agenda" class="mb-x2"/>
            <BottomSheetClick name="image delivery" :content="eventData.delivery_instructions" class="mb-x2"/>
            <BottomSheetClick name="reimbursable items" html :htmlcontent="hardcodedContent" class="mb-x2"/>
            <BottomSheetClick name="invoice instructions" :content="hardcodedContent" class="mb-x2"/>
            <BottomSheetClick name="equipment" html :htmlcontent="eventData.equipment" class="mb-x2"/>
            <BottomSheetClick name="offsite info" :content="eventData.offsite" class="mb-x2"/>
          </template>
          <!-- LOCAL containers -->
          <template v-else>
            <BottomSheetClick name="parking & arrival" :content="eventData.travel" class="mb-x2"/>
            <BottomSheetClick name="travel dates" :content="eventData.traveldates" class="mb-x2"/>
            <BottomSheetClick name="flight / hotel" :content="eventData.flighthotel" class="mb-x2" image/>
            <BottomSheetClick name="team assignments" :content="eventData.assignments" class="mb-x2" image/>
            <BottomSheetClick name="headshot cafe" :content="eventData.headshotcafe" class="mb-x2"/>
            <BottomSheetClick name="video" :content="eventData.video" class="mb-x2"/>
            <BottomSheetClick name="services" :content="eventData.services" class="mb-x2"/>
            <BottomSheetClick name="onsite info" :content="eventData.onsite" class="mb-x2"/>
            <BottomSheetClick name="meals" :content="eventData.meals" class="mb-x2"/>
            <BottomSheetClick name="additional details" :content="eventData.details" class="mb-x2"/>
            <BottomSheetClick name="EC Photog guidelines" :content="eventData.guidelines" class="mb-x2"/>
            <BottomSheetClick name="EC program agenda" :content="eventData.agenda" class="mb-x2"/>
            <BottomSheetClick name="image delivery" :content="eventData.delivery_instructions" class="mb-x2"/>
            <BottomSheetClick name="reimbursable items" :content="hardcodedContent" class="mb-x2"/>
            <BottomSheetClick name="invoice instructions" :content="hardcodedContent" class="mb-x2"/>
          </template>
        </div>
      </div>
      <!-- <div class="row mb-x4">
        <div class="col-md-6" v-if="zohoId">
          <pre>{{ zohoConsole }}</pre>
          <div class="mb-x2" v-for="(datum, index) in zohoData" :key="index">
            <h6>{{ index }}</h6>
            <p v-if="datum">{{ datum }}</p>
            <p class="italic color-grayscale-2" v-else>no value</p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'
import CreativesList from '@/components/CreativesList.vue'
import PageLoader from '@/components/PageLoader.vue'
import BottomSheetClick from '@/components/BottomSheetClick.vue'
import shared from '@/shared.js'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

// Using route params
// $route.params.id
// from path: '/user/:id',

export default {
  name: 'home',
  components: {
    Nav,
    CreativesList,
    PageLoader,
    BottomSheetClick
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      eventId: '',
      zohoId: '',
      zohoData: '',
      zohoConsole: '',
      eventData: {
        'event_name': '',
        'location': '',
        'floorplan_path': '',
        'calltime': '',
        'agenda': '',
        'onsite': '',
        'guidelines': '',
        'invoice': '',
        'travel': '',
        'creatives': '',
        'days': [],
        'services': '',
        'meals': '',
        'details': '',
        'delivery_instructions': '',
        'reimbursable': '',
        'headshotcafe': '',
        'video': '',
        'traveldates': '',
        'flighthotel': '',
        'assignments': '',
        'equipment': '',
        'offsite': ''
      },
      users: [],
      bottomSheetOpen: false,
      hardcodedContent: 'Read the job sheet',
      zohoError: '',
      cachedon: ''
    }
  },
  created () {
    this.isLoading = true
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.eventid) {
      if (this.$route.params.eventid.slice(0, 1) === 'z') {
        this.zohoId = this.$route.params.eventid.slice(1)
        this.getZohoJob()
      } else {
        this.eventId = this.$route.params.eventid
        this.getEvent()
      }
    } else {
      this.$router.go(-1)
    }
  },
  methods: {
    getEvent () {
      axios
        .get(apiChoice + 'api/events/' + this.eventId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.eventData = response.data
          this.getUsers()
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    getZohoJob (force = false) {
      this.isLoading = true
      let forceParam = ''
      if (force) {
        forceParam = '/force'
      }
      axios
        .get(apiChoice + 'api/zohodeal/' + this.zohoId + forceParam, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          // this.zohoJobs = response.data.data
          this.cachedon = 'cachedon' in response.data ? this.parseDate(response.data.cachedon.split(' ')[0]) + ' ' + this.amPmConvert(response.data.cachedon.split(' ')[1]) : ''

          if (response.data.hasOwnProperty('data')) {
            // this one is for local usage
            let zohoResponse = response.data.data[0]

            // build travel section
            let travelHTML = ''
            if ('Specific_Arrival_Inst' in zohoResponse && zohoResponse.Specific_Arrival_Inst) {
              travelHTML += '<div class="mb-x2"><h6>Arrival Instructions</h6>' + zohoResponse.Specific_Arrival_Inst + '</div>'
            }
            if ('Parking_Validation_Inst' in zohoResponse && zohoResponse.Parking_Validation_Inst) {
              travelHTML += '<div class="mb-x2"><h6>Parking Validation</h6>' + zohoResponse.Parking_Validation_Inst + '</div>'
            }
            if ('Credentials_Pick_Up' in zohoResponse && zohoResponse.Credentials_Pick_Up) {
              travelHTML += '<div class="mb-x2"><h6>Credentials</h6>' + zohoResponse.Credentials_Pick_Up + '</div>'
            }

            // build travel dates section NO LONGER IN USE SEE BELOW
            let travelDatesHTML = ''

            // build travel dates section
            let flightHotelHTML = ''
            if (Array.isArray(zohoResponse.Talent_Travel_Info)) {
              zohoResponse.Talent_Travel_Info.forEach((talent) => {
                if ('Assigned_Talent' in talent && talent.Assigned_Talent && 'name' in talent.Assigned_Talent) {
                  flightHotelHTML += '<div class="mb-x4">' // opening
                  flightHotelHTML += '<h5 class="mb-x1">' + talent.Assigned_Talent.name + '</h5>'
                  flightHotelHTML += '<div class="mb-x2"><h6>Flight Confirmation</h6>' + talent.Flight_Conf + '</div>'
                  if (talent.Arrival_Date) {
                    flightHotelHTML += '<div class="mb-x2"><h6>Arrival</h6>' + this.parseDate(this.parseTimestamp(talent.Arrival_Date)) + ' - ' + this.parseTimestamp(talent.Arrival_Date, 'time') + '</div>'
                  }
                  if (talent.Depart_Date) {
                    flightHotelHTML += '<div class="mb-x2"><h6>Departure</h6>' + this.parseDate(this.parseTimestamp(talent.Depart_Date)) + ' - ' + this.parseTimestamp(talent.Depart_Date, 'time') + '</div>'
                  }
                  flightHotelHTML += '<div class="mb-x2"><h6>Hotel Info</h6>' + talent.Hotel_Info + '</div>'
                  flightHotelHTML += '<div class="mb-x2"><h6>Hotel Confirmation</h6>' + talent.Hotel_Conf + '</div>'
                  flightHotelHTML += '</div>' // closing
                }
              })
            }

            // build team assignments section
            let teamAssignmentHTML = ''
            if (Array.isArray(zohoResponse.Talent1)) {
              zohoResponse.Talent1.forEach((talent) => {
                if ('Assigned_Talent' in talent && talent.Assigned_Talent && 'name' in talent.Assigned_Talent) {
                  teamAssignmentHTML += '<div class="mb-x4">' // opening
                  teamAssignmentHTML += '<h5 class="mb-x1">' + talent.Assigned_Talent.name + '</h5>'
                  teamAssignmentHTML += '<div class="mb-x2"><h6>Email</h6>' + talent.Email + '</div>'
                  let role = talent.Role_Position ? talent.Role_Position : 'unassigned'
                  teamAssignmentHTML += '<div class="mb-x2"><h6>Role/Position</h6>' + role + '</div>'
                  teamAssignmentHTML += '</div>' // closing
                }
              })
            }

            // build THSC assignments section
            let headshotcafeHTML = ''
            if ('THSC_Start_Date' in zohoResponse && zohoResponse.THSC_Start_Date) {
              headshotcafeHTML += '<div class="mb-x2"><h6>Start</h6>' + this.parseDate(this.parseTimestamp(zohoResponse.THSC_Start_Date)) + ' - ' + this.parseTimestamp(zohoResponse.THSC_Start_Date, 'time') + '</div>'
            }
            if ('THSC_End_Date' in zohoResponse && zohoResponse.THSC_End_Date) {
              headshotcafeHTML += '<div class="mb-x2"><h6>End</h6>' + this.parseDate(this.parseTimestamp(zohoResponse.THSC_End_Date)) + ' - ' + this.parseTimestamp(zohoResponse.THSC_End_Date, 'time') + '</div>'
            }
            if ('THSC_Scope' in zohoResponse && zohoResponse.THSC_Scope) {
              headshotcafeHTML += '<div class="mb-x2"><h6>Scope</h6>' + zohoResponse.THSC_Scope + '</div>'
            }
            if ('THSC_Agenda' in zohoResponse && zohoResponse.THSC_Agenda) {
              headshotcafeHTML += '<div class="mb-x2"><h6>Agenda</h6>' + zohoResponse.THSC_Agenda + '</div>'
            }
            if ('THSC_Delivery_Info' in zohoResponse && zohoResponse.THSC_Delivery_Info) {
              headshotcafeHTML += '<div class="mb-x2"><h6>Delivery Info</h6>' + zohoResponse.Delivery_Info + '</div>'
            }

            // build Video assignments section
            let videoHTML = ''
            if ('Videography_Details' in zohoResponse && zohoResponse.Videography_Details) {
              videoHTML += '<div class="mb-x2"><h6>Videography Details</h6>' + zohoResponse.Videography_Details + '</div>'
            }
            if ('Video_Delivery' in zohoResponse && zohoResponse.Video_Delivery) {
              videoHTML += '<div class="mb-x2"><h6>Video Delivery</h6>' + zohoResponse.Video_Delivery + '</div>'
            }

            // build Onsite assignments section
            let onsiteHTML = ''
            if ('Onsite_Contact' in zohoResponse && zohoResponse.Onsite_Contact) {
              onsiteHTML += '<div class="mb-x2"><h6>Onsite Contact</h6>' + zohoResponse.Onsite_Contact + '</div>'
            }
            if ('Onsite_Phone' in zohoResponse && zohoResponse.Onsite_Phone) {
              onsiteHTML += '<div class="mb-x2"><h6>Onsite Phone</h6>' + zohoResponse.Onsite_Phone + '</div>'
            }
            if ('Onsite_Staff_Room' in zohoResponse && zohoResponse.Onsite_Staff_Room) {
              onsiteHTML += '<div class="mb-x2"><h6>Onsite Staff Room</h6>' + zohoResponse.Onsite_Staff_Room + '</div>'
            }

            // build Details assignments section
            let detailsHTML = ''
            if ('Event_Description' in zohoResponse && zohoResponse.Event_Description) {
              detailsHTML += '<p class="mb-x2">' + zohoResponse.Event_Description + '</p>'
            }
            if ('Event_URL' in zohoResponse && zohoResponse.Event_URL) {
              zohoResponse.Event_URL = zohoResponse.Event_URL.includes('http') ? zohoResponse.Event_URL : 'http://' + zohoResponse.Event_URL
              detailsHTML += '<a href="' + zohoResponse.Event_URL + '" target=_blank>' + zohoResponse.Event_URL + '</a>'
            }

            // build Equipment section
            let equipHTML = ''
            if ('Shipping_Instructions' in zohoResponse && zohoResponse.Shipping_Instructions) {
              equipHTML += '<div class="mb-x2"><h6>Shipping Instructions</h6>' + zohoResponse.Shipping_Instructions + '</div>'
            }
            if ('Equipment_Needed' in zohoResponse && zohoResponse.Equipment_Needed) {
              equipHTML += '<div class="mb-x2"><h6>Equipment Needed</h6>' + zohoResponse.Equipment_Needed + '</div>'
            }

            // build days
            for (let step = 1; step < 7; step++) {
              let startIterator = 'Day_0' + step + '_Start'
              let endIterator = 'Day_0' + step + '_End'
              if (zohoResponse[startIterator]) {
                this.eventData.days.push({
                  'date': this.parseTimestamp(zohoResponse[startIterator]),
                  'start_time': this.parseTimestamp(zohoResponse[startIterator], 'time'),
                  'end_time': this.parseTimestamp(zohoResponse[endIterator], 'time')
                })
              }
            }

            // top
            this.zohoWorks = true
            this.eventData.event_name = zohoResponse.Deal_Name
            this.eventData.location = zohoResponse.Shoot_Locations
            this.eventData.calltime = 'Call_Time' in zohoResponse && zohoResponse.Call_Time ? zohoResponse.Call_Time : '15 min before start time'
            // containers
            this.eventData.travel = travelHTML
            this.eventData.traveldates = travelDatesHTML
            this.eventData.flighthotel = flightHotelHTML
            this.eventData.assignments = teamAssignmentHTML
            this.eventData.headshotcafe = headshotcafeHTML
            this.eventData.video = videoHTML
            this.eventData.services = 'Event_Services' in zohoResponse ? zohoResponse.Event_Services : []
            this.eventData.onsite = onsiteHTML
            this.eventData.meals = 'Meals_Protocol' in zohoResponse ? zohoResponse.Meals_Protocol : ''
            this.eventData.details = detailsHTML
            this.eventData.guidelines = 'Shot_List_Guidelines1' in zohoResponse ? zohoResponse.Shot_List_Guidelines1 : ''
            this.eventData.agenda = 'Program_Agenda' in zohoResponse ? zohoResponse.Program_Agenda : ''
            this.eventData.delivery_instructions = 'Staff_Instructions' in zohoResponse ? zohoResponse.Staff_Instructions : ''
            this.eventData.reimbursable = ''
            this.eventData.invoice = 'Special_Expense_or_Invoicing_details' in zohoResponse ? zohoResponse.Special_Expense_or_Invoicing_details : ''
            this.eventData.equipment = equipHTML
            this.eventData.offsite = 'Off_Site_Location' in zohoResponse ? zohoResponse.Off_Site_Location : ''
            // revisit to lock in  talent1 is there, assigned talent is there and name is there
            this.eventData.creatives = Array.isArray(zohoResponse.Talent1) ? zohoResponse.Talent1.flatMap((talent) => talent.Assigned_Talent ? [talent.Assigned_Talent.name] : []).join(',') : ''
          } else {
            console.log(response.data)
            this.zohoWorks = false
            // this is the error handler
            this.zohoError = 'error_description' in response.data ? response.data.error_description : JSON.stringify(response.data)
          }
          this.getUsers()
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.isLoading = false
        })
      // let testData = {
      //   'Job_Start': '2024-07-08T06:00:00-04:00',
      //   'Job_End': '2024-07-10T06:00:00-04:00',
      //   'Shoot_Locations': 'Walter E. Washington Convention Center',
      //   'Deal_Name': 'FREEMAN2024NATO',
      //   'id': '6099044000081687058'
      // }
    },
    getUsers () {
      axios
        .get(apiChoice + 'api/users', {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // transfer the response
          this.users = response.data
        })
        .catch((error) => {
          console.log(error.response.data)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    parseDate (timestamp, dateSegment = 0) {
      return shared.parseDate(timestamp, dateSegment)
    },
    amPmConvert (time) {
      return shared.amPmConvert(time)
    },
    parseTimestamp (timestamp, part) {
      return shared.parseTimestamp(timestamp, part)
    }
  }
}
</script>

<style scoped lang="scss">
.main{
  padding-bottom: 80px;
}
.bottom-sheet-open{
  overflow-y: hidden;
}
// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
